{
	"year": {
		"previous": "last yr.",
		"current": "this yr.",
		"next": "next yr.",
		"past": "{0} yr. ago",
		"future": "in {0} yr."
	},
	"quarter": {
		"previous": "last qtr.",
		"current": "this qtr.",
		"next": "next qtr.",
		"past": {
			"one": "{0} qtr. ago",
			"other": "{0} qtrs. ago"
		},
		"future": {
			"one": "in {0} qtr.",
			"other": "in {0} qtrs."
		}
	},
	"month": {
		"previous": "last mo.",
		"current": "this mo.",
		"next": "next mo.",
		"past": "{0} mo. ago",
		"future": "in {0} mo."
	},
	"week": {
		"previous": "last wk.",
		"current": "this wk.",
		"next": "next wk.",
		"past": "{0} wk. ago",
		"future": "in {0} wk."
	},
	"day": {
		"previous": "yesterday",
		"current": "today",
		"next": "tomorrow",
		"past": {
			"one": "{0} day ago",
			"other": "{0} days ago"
		},
		"future": {
			"one": "in {0} day",
			"other": "in {0} days"
		}
	},
	"hour": {
		"current": "this hour",
		"past": "{0} hr. ago",
		"future": "in {0} hr."
	},
	"minute": {
		"current": "this minute",
		"past": "{0} min. ago",
		"future": "in {0} min."
	},
	"second": {
		"current": "now",
		"past": "{0} sec. ago",
		"future": "in {0} sec."
	},
	"now": {
		"future": "in a moment",
		"past": "just now"
	}
}